import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import React from "react"
import { FormattedMessage, FormattedNumber, injectIntl } from "react-intl"
import GlobalHelper from "../common/GlobalHelper.jsx"
import Icon from "../common/icon/icon.component.jsx"
import InputUnitOfMeasure from "../common/unit-of-measure/input.component.jsx"
import Addon, { AddonDto } from "../state/billing/Addon"

type OwnProps = {
    a: AddonDto,
    key: string,
    selectedAddonsMap: object,
    chooseAddon: (addonId: string) => void,
    chooseAddonInput: (addonId: string, quantityEvent: string) => void,
    getModulesMessages: () => moduleMessages[],
    formatPrice: (price: string) => number,
    currency: string,
}

type moduleMessages = {
    hidden: boolean,
    module: string,
    message: string,
}

function ChoosePlanAddon(props: OwnProps) {
    const addon = new Addon(props.a)
    const isSelected = Object.keys(props.selectedAddonsMap).includes(addon.getId())
    const price = props.formatPrice(addon.getPrice())
    const defaultLanguage = AppContext.getAccount().attributes.defaultLanguage

    const onClick = () => {
        props.chooseAddon(addon.getId())
    }

    const getAddonQuantity = () => {
        if (!addon.isAddonWithQuantity()) {
            return <div className="w-100">
                <div className="card-text text-center border-top-0 py-2 mb-0 mt-2">
                    <input type={"radio"} checked={isSelected} onChange={onClick}/>
                </div>
                <div className="card-text text-center mb-0">
                    <button
                        className={"btn btn-primary padding-left-0-for-inner-span" + (isSelected ?
                            " btn-success" : " btn-secondary")}
                        onClick={onClick}>
                        {isSelected ? <FormattedMessage
                            id="myaccount.choose_plan.selected_btn"
                            defaultMessage="Selected"
                        /> : <FormattedMessage
                            id="myaccount.choose_plan.choose_btn"
                            defaultMessage="Choose"
                        />}
                        {isSelected ? <Icon className={"ml-1"} value={"check"}/> : ""}
                    </button>
                </div>
            </div>
        }
        return <div>
            <InputUnitOfMeasure
                debounced={true}
                value={props.selectedAddonsMap[addon.getId()] ? props.selectedAddonsMap[addon.getId()] : "0"}
                onChange={(val) => props.chooseAddonInput(addon.getId(), val)}
                format={"short"}
            />
        </div>
    }

    return (<div className={"col-12 col-sm-8 col-lg-4 card py-3 mr-3 mb-3" + (isSelected ? " border-success" : "")}
        key={props.key}>
        <div className={"row"}>
            <div className={"col-12 d-flex justify-content-center align-items-center"}>
                <div className={"col-4"}>
                    {getAddonQuantity()}
                </div>
                <div className={"card-body d-flex flex-column justify-content-between p-2"}>
                    <div className={"w-100"} style={!addon.isAddonWithQuantity() ? {minHeight: "150px"} : {}}>
                        <h3 className={"custom-lead d-inline-flex"}>
                            <span className="d-inline-flex">
                                <FormattedMessage
                                    id="myaccount.subscription.addon_tag"
                                    defaultMessage="{nameAndPrice}"
                                    values={{
                                        nameAndPrice: <div className="d-inline-flex">
                                            <div className="mr-2">
                                                {addon.getAddonName(defaultLanguage)}
                                            </div>

                                            <small>
                                                {price > 0 ?
                                                    <span className="d-inline-flex">
                                                        <FormattedNumber
                                                            style="currency"
                                                            maximumFractionDigits={0}
                                                            currencyDisplay={"symbol"}
                                                            currency={props.currency}
                                                            value={props.formatPrice(addon.getPrice())}
                                                        />
                                                        <small>
                                                            {addon.getIntervalType() == "month" ?
                                                                <small>
                                                                    <FormattedMessage
                                                                        id="myaccount.subscription.monthly_price_unit"
                                                                        defaultMessage="/month"
                                                                    />
                                                                </small> :

                                                                <small>
                                                                    <FormattedMessage
                                                                        id="myaccount.subscription.yearly_price_unit"
                                                                        defaultMessage="/year"
                                                                    />
                                                                </small>
                                                            }
                                                        </small>
                                                    </span> : <FormattedMessage
                                                        id="myaccount.subscription.free"
                                                        defaultMessage="Free"
                                                    />}
                                            </small>
                                        </div>,
                                    }}
                                />
                            </span>
                        </h3>

                        {!addon.isAddonWithQuantity() && < div className="card-text w-100 py-2 px-2">
                            <div className={"mt-2 mb-0 "} style={{ whiteSpace: "pre-line" }}>
                                {addon.getAddOnDescription(defaultLanguage) ?
                                    addon.getAddOnDescription(defaultLanguage) :
                                    props.getModulesMessages()
                                        .filter(m => !m.hidden)
                                        .map((m, index) => {
                                            return (addon.hasFeature(m.module) ?
                                                <div key={index}>
                                                    <span className="">
                                                        {m.message}
                                                    </span>
                                                    <br/>
                                                </div> : "")
                                        })}
                            </div>
                        </div>}

                        {!GlobalHelper.hasShopifyIntegrationWithDisabledFeatures() && addon.getAddDisplayDescriptionFooter() &&
                            <div className="card-text mb-0">
                                <small>
                                    <FormattedMessage
                                        id="myaccount.choose_plan.bank_transfer"
                                        defaultMessage="{fee}{amount}{cap}"
                                        values={{
                                            fee: parseFloat(addon.getBankTransferFeePercentage()) > 0 ?
                                                <FormattedMessage
                                                    id="myaccount.choose_plan.bank_transfer.ach_fee"
                                                    defaultMessage="{nb}% ACH fee"
                                                    values={{nb: addon.getBankTransferFeePercentage()}}
                                                /> : " ",
                                            amount: parseFloat(addon.getBankTransferFeeAmount()) > 0 ? <FormattedMessage
                                                id="myaccount.choose_plan.bank_transfer.ach_amount"
                                                defaultMessage="+ ${nb} per transaction"
                                                values={{nb: addon.getBankTransferFeeAmount()}}
                                            /> : " ",
                                            cap: parseFloat(addon.getBankTransferFeeCap()) > 0 ? <FormattedMessage
                                                id="myaccount.choose_plan.bank_transfer.ach_cap"
                                                defaultMessage="/ {nb}$ cap"
                                                values={{nb: addon.getBankTransferFeeCap()}}
                                            /> : " ",
                                        }}
                                    />
                                </small>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>)
}

export default injectIntl(ChoosePlanAddon)


// WEBPACK FOOTER //
// ./src/my-account/chooseplanaddon.component.tsx